import { render } from "./PromptElements.vue?vue&type=template&id=3aa43fbc&scoped=true&ts=true"
import script from "./PromptElements.vue?vue&type=script&lang=ts"
export * from "./PromptElements.vue?vue&type=script&lang=ts"

import "./PromptElements.vue?vue&type=style&index=0&id=3aa43fbc&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa43fbc"]])

export default __exports__